<!--
 * @Date: 2024-07-19 12:53:28
 * @LastEditors: p彭 9878922+p-pengrulin@user.noreply.gitee.com
 * @LastEditTime: 2024-09-29 13:25:15
-->
<template>
  <CursorFollower />
  <!--注册路由的组件-->
  <router-view />
</template>

<script>
//import BGMPlayer from '@/components/BGMPlayer.vue';
//import LoadingData from './components/LoadingData.vue';
import { debugToWindow } from "./utils/common_method.js";
import { setWalletConnection, setWallet } from "./utils/common_method.js";
import { reconnect } from "@wagmi/core";
import CursorFollower from "@/components/CursorFollower/index.vue";
//import LightMode from './components/LightMode.vue';
import { isMobile } from "@/utils/common_method";

export default {
  components: {
    CursorFollower,
    //Mask,
    //LightMode,
  },
  data() {
    return {
      isLoading: true, //isLoading
    };
  },
  methods: {},
  mounted() {
    setWallet();
    setWalletConnection();
    if (localStorage.getItem("walletconnect") === "true") {
      let collection = window.walletConnection;
      collection.setConfig();
      collection.watchers();
      reconnect(collection.config);
    }
    setTimeout(() => {
      this.isLoading = false; // When finished,  set isLoading = false
    }, 2000);
  },

  watch: {
    "$store.state": {
      deep: true, //深度监听设置为 true
      handler: function (newVal) {
        debugToWindow("store", newVal);
      },
    },
  },
};
</script>

<style>
#app {
  font-family: Quicksand, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #000;
  background-color: #fff;
  cursor: url("~@/assets/cursor.png"), auto;
  width: calc(100vw - 1px);
  height: 100%;
}

body {
  cursor: url("~@/assets/cursor.png"), auto;
  margin: 0;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  height: 100%;
}
</style>
